var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdvertising = function SvgAdvertising(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#4A4A4A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.696
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 2h15v13.217H3zm3.571 16v-2.783H4.429V18m12.142 0v-2.783h-2.142V18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.429 12.783c0 .192-.16.347-.358.347h-3.928V4.998c0-.121.064-.233.17-.296a.36.36 0 0 1 .347-.015l3.571 1.739c.121.059.198.18.198.31v6.047zm-.715-6.609V4.435m-3.571 3.13h1.428m-5 1.392H8m-1.429 1.391H8m2.143-1.391h2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.143 7.565H6.929a.353.353 0 0 0-.358.348v4.87c0 .192.16.347.358.347h3.214m1.428 0v-1.043c0-.192.16-.348.358-.348h.714c.197 0 .357.156.357.348v1.043"
  }))));
};
export default SvgAdvertising;